export const applicationName = {
    intranet: 1,
    conference: 4,
    timesheetApproval: 13,
    siteServiceSecurityTimesheet: 17,
    attendanceObservation: 15,
    infoboardManagement: 10,
    chipFacility: 19,
    costCenterManagement: 22,
    resumeApproval: 23,
    sportClubReservation: 27,
    newsManagement: 36,
    aboutManagement: 28,

}

export const applicationComponentIds = {
    conference: 38,
    photoConfirmation: 83,
    domesticNewsManagement: 84,
    facilityChip: 90,
    attendanceObservation: 78,

    cartable: 94,
    personnalInformation: 95,
    kasraSystem: 96,
    complementaryInsurance: 97,
    salaryReceipt: 98,
    loanRequest: 99,
    coffeeshop: 100,
    personnelCommute: 101,
    timesheetManagement: 102,
    timesheetModification: 103,
    timesheetSiteAndService: 104,
    timesheetReporting: 105,
    presentStaffReport: 108,
    sportClub: 129
}

export const systemPersonnalMenu = {
    personnalMenu: 21
}

export const applicationsRole = {      
    general: {             
        headSection: 1,                                 //	سرپرست زیر بخش
        engineeringManager: 2,                          //	مدیر مهندسی	
        projectEngineer: 3,	                            //  مهندس پروژه	
        dccSupervisor: 4,	                            //  سرپرست DCC	
        disciplineCoordinator: 5,	                    //  هماهنگ کننده دیسیپلین	
        employee: 6,                	                //  کارمند	
        engineeringAffairs: 7,                          //	امور مهندسی	
        vendor: 8,                                      //	سازنده	
        sectionManager: 9,                              //	مدیر بخش	
        projectManager: 10,                             //	مدیر پروژه	
        owner: 11,	                                    //  کارفرما
        licensor: 12,	                                //  Licensor
        siteSupervisor: 13,                             //	سرپرست سایت	
        siteManager: 14,                                //	مدیر سایت	
        affairsManager: 15,                             //  مدیر امور	
        qhseIntermediary: 16,                           //  رابط QHSE	
        qhseExpert: 17,                                 //  کارشناس QHSE		
        qhseEditor: 18,                                 //  ویراستار QHSE		
        managingDirector: 19,                           //	مدیر عامل	
        workshopEngineeringSupervisor: 20,              //	سرپرست مهندسی کارگاهی	
        workshopEngineeringCoordinator: 21,             //	هماهنگ کننده مهندسی کارگاهی	
        fdcc: 22,	                                    //  FDCC	
        workshopOwner: 23,                              //	کارفرمای سایت	
        ownerWithMc: 24,                                //	OwnerWithMc
        ownerCoordinator: 25,                           //	هماهنگ کننده کارفرما	
        ownerDCC: 26,                                   //	کارفرما DCC	
        notSet: 27,                                     //  ------	
        ownerEngineeringManager: 28,                    //  مدیرمهندسی کارفرما	
        ownerHeadSection: 29,             	            //  سرپرست بخش کارفرما	
        ownerProjectManager: 30,                        //	مدیر پروژه کارفرما	
        toVendorChecker: 31,                            //	بررسی کننده جهت ارسال به سازنده	
        ownerofOwner: 32,                               //	کارفرمای کارفرما	
        roleLess: 33,                                   //  بدون نقش	
        SectionSecretary: 34,                           //  منشی بخش	
        systemAdministrator: 35,	                    //  Admin
        itPersonnels:36,                                //  پرسنل واحد آی تی
        temporary:37,                                   //  رول موقت برای کارهای کوتاه مدت
        conferenceSystemAdministration: 39,             //  ادمین سیستم اتاق جلسات
        nonStaffUser: 44,                               //  کابر غیر پرسنل
        attendanceObservation: 1013,                    //  مشاهده حضور و غیاب کلی پرسنل
        chilFacility: 1014,                             //  بن رفاهی
        videoNews: 1020,                                //  آپلود ویدیوها آموزشی 
        sportClubReservationSystemAdministration: 53,   //  ادمین سیستم اتاق جلسات
        // Conference reservation Exception with setting access only: 1004	استثناء رزرواسیون جلسات، دسترسی تنظیمات فقط	
    },
    infoboard: {
        infoboardExceptionWithFullAccess: 1001,	        // استثناء تابلو اعلانات، دسترسی کامل
        infoboardExceptionWithCreateAccessOnly: 1002,   // استثناء تابلو اعلانات، دسترسی ایجاد فقط	
        infoboardExceptionWithRemoveAccessOnly: 1003,   // استثناء تابلو اعلانات، دسترسی حذف فقط	
        infoboardExceptionWithModifyAccessOnly: 1017,   // استثناء تابلو اعلانات، دسترسی ویرایش فقط	

    },    
    chatRoom: {
        chatSystemExceptionwithCreateGroupOnly: 1005,	// استثناء سیستم گفتگو، دسترسی ایجاد گروه فقط	
        chatSystemExceptionwithDeleteGroupOnly: 1006,	// استثناء سیستم گفتگو، دسترسی حذف گروه فقط	
    },
    photoConfirmation: {
        disciplineManager: 9,                           // تایید عکس پرسنل توسط مدیر بخش استخدام
        projectManager: 10,                             // تایید عکس پرسنل توسط پروژه بخش استخدام
        secondConfirmation: 1009,                       // مدیر منابع انسانی یا تایید کننده دوم
        uploadOtherPersonnelPhotos: 1010                // بارگذاری (آپلود) عکس سایرین
    },

    reports: {
        presentStaffDetailRepost: 1019                  //استثناء مشاهده جزئیات  پرسنل حاضر در شرکت
    },

    siteServiceSecurityTimesheet: {
        siteServiceSecurityRegistrar: 40,               // ثبت کننده هر سه نوع تایم شیت سایت، خدمات و حراست
        siteRegistrar: 41,                              // ثبت کننده تایم شیت سایت
        serviceRegistrar: 42,                           // ثبت کننده تایم شیت خدمات 
        securityRegistrar: 43,                          // ثبت کننده تایم شیت حراست      
    },

    costCenterManagement: {
        costCenterManagementManipulatorReadOnlyAccess: 50,      // دسترسی فقط خواندنی مراکز هزینه
        costCenterManagementManipulatorFullAccess: 49,          // دسترسی کامل ثبت کننده اطلاعات مراکز هزینه
        costCenterManagementManipulator: 45,                    // ثبت کننده اطلاعات مراکز هزینه
        costCenterMarketingProjectManagementManipulator: 47,    // ثبت کننده اطلاعات مراکز هزینه پروژه های کاریابی
        costCenterSubCodeManagementManipulator: 48,             // ثبت کننده اطلاعات زیربخش مراکز هزینه
        costCenterActivityManagementManipulator: 46,            // ثبت کننده اطلاعات فعالیت های مراکز هزینه
    },

    resumeApprovalManagement: {
        resumeApprovalViewOnlyDataAccess: 51,                   // مشاهده رزومه پرسنل
        resumeApprovalConfirmationDataAccess: 52,               // تایید رزومه پرسنل
    },

    aboutEiedlManagement: {
        aboutEiedlManagementAccess: 54,                         // مدییت درباره EIED
        aboutEiedlManagementFullAccess: 55,                     // دسترسی کامل مدییت درباره EIED
        aboutEiedlManagementDocumentUploader: 56,               // بارگذارنده مدارک مدیریت درباره EIED
        aboutEiedlManagementDocumentRemover: 57,                // حذف کننده مدارک مدیریت درباره EIED
    }                     
}


export const applicationsComponentPermissions = {
    conferenceSystem: {
        conferenceView: 38,                             //رزرواسیون اتاق جلسات
        conferenceAdd: 40,                              //ایجاد یک رزرواسیون 
        conferenceDelete: 41,                           //حذف یک رزرواسیون
        conferenceUpdate: 43,                           //ویرایش یک رزرواسیون
        conferenceSetting: 60,                          //تنظیمات اتاق جلسات
        conferenceConfirmation: 74,                     //تایید جلسات
        conferenceReporting: 107                        //گزارش جلسات
    },

    siteServiceSecurityTimesheet: {
        accessFull: 85,                                 // دسترسی کامل برای ثبت هر سه نوع تایم شیت
        accessSite: 86,                                 // دسترسی کامل برای ثبت تایم شیت سایت
        accessService: 87,                              // دسترسی کامل برای ثبت تایم شیت خدمات
        accessSecurity: 88                              // دسترسی کامل برای ثبت تایم شیت حراست
    },

    infoBoardManagement: {
        Infoboardmanagement: 57,                                        // مدیریت تابلو اعلانات
        InfoboardDeletion: 58,                                          // حذف اطلاعیه
        InfoboardInsertion: 59,                                         // درج اطلاعیه
        InfoboardModification: 106,                                     // ویرایش اطلاعیه
    InfoboardSearchAll: 61,                                             // مشاهده کلی اطلاعیه ها
    },

    costCenterManagement: {
        costCenterManagement: 109,                                      // مدیریت تابلو اعلانات
        CostCenterManagementAdd: 110,                                   // ایجاد مرکز هزینه جدید
        CostCenterManagementModify: 112,                                // ویرایش مرکز هزینه موجود
        CostCenterManagementMarketingProjectInformationModify: 115,     // ویرایش اطلاعات پروژه کاریابی
        CostCenterManagementSubSectionAdd: 117,                         // اضافه کردن اطلاعات زیربخش مرکز هزینه

        CostCenterManagementActivities: 114,                            // فعالیت های مرکز هزینه موجود
        CostCenterActivityManagementAdd: 118,                           // ایجاد فعالیت جدید مرکز هزینه
        CostCenterActivityManagementModify: 119,                        // ویرایش فعالیت جدید مرکز هزینه
        CostCenterActivityManagementAddFromFile: 120,                   // ایجاد فعالیت جدید مرکز هزینه از فایل
        CostCenterActivityManagementBatchDelete: 121,                   // حذف دسته ای فعالیت های مرکز هزینه 
        CostCenterActivityManagementBatchUndelete: 122,                 // بازیابی دسته ای فعالیت های حذف شده مرکز هزینه 
        CostCenterActivityManagementBatchActivate: 123,                 // فعال سازی دسته ای فعالیت های مرکز هزینه 
        CostCenterActivityManagementBatchDeactivate: 124,               // غیر فعال سازی دسته ای فعالیت های مرکز هزینه
        CostCenterActivityManagementExcelExport: 125,                   // خروجی اکسل فعالیت های مرکز هزینه
    },
    
    sportClubReservation: {
        sportClubReservationView: 129,                                  //رزرواسیون باشگاه ورزشی
        sportClubReservationAdd: 130,                                   //ایجاد یک رزرواسیون باشگاه ورزشی 
        sportClubReservationDelete: 131,                                //حذف یک رزرواسیون باشگاه ورزشی 
        sportClubReservationUpdate: 133,                                //ویرایش یک رزرواسیون باشگاه ورزشی
        sportClubReservationSetting: 134,                               //تنظیمات رزرواسیون باشگاه ورزشی
        sportClubReservationConfirmation: 135,                          //تایید رزرواسیون باشگاه ورزشی
        sportClubReservationReporting: 136                              //گزارش رزرواسیون باشگاه ورزشی
    },
}